// extracted by mini-css-extract-plugin
export var centerText = "_e2-8";
export var container = "_e2-0";
export var doughnutContainer = "_e2-7";
export var legend = "_e2-a";
export var legendItemColorDisplay = "_e2-b";
export var legendItemLabel = "_e2-d";
export var legendItemValue = "_e2-c";
export var lg = "_e2-5";
export var maxWidth = "_e2-9";
export var md = "_e2-4";
export var responsive = "_e2-6";
export var sm = "_e2-3";
export var xs = "_e2-2";
export var xxs = "_e2-1";